module.exports = __webpack_public_path__ + "media/images/photo/arow-2a7c8728358ec8bac30fb5106f9e8989.svg";